import { connect, Dispatch } from 'react-redux';
import { DeviceInfoPage, ConnectedProps, ActionProps } from './component';
import { AppState } from '../app/state';
import { GetTenantAction } from 'pages/settings/actions';
import { GetDeviceIdAction, UnregisterDeviceAction } from './actions';
import { tenantSelector, languageSelector } from 'pages/settings/selectors';
import { permissionsSelector } from 'pages/login/selectors';
import { connectionSelector } from 'components/connection-status/selectors';

const mapStateToProps = (state: AppState): ConnectedProps => {
  return {
    isOnline: connectionSelector(state),
    language: languageSelector(state),
    permissions: permissionsSelector(state),
    deviceId: state.deviceInfo.deviceId,
    tenantId: tenantSelector(state).id,
    countryCode: tenantSelector(state).countryCode
  };
};

function mapDispatchToProps(dispatch: Dispatch<GetTenantAction>): ActionProps {
  return {
    getDeviceInfo: () => {
      dispatch(new GetTenantAction());
      dispatch(new GetDeviceIdAction());
    },
    unregisterDevice: () => dispatch(new UnregisterDeviceAction())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceInfoPage);


// WEBPACK FOOTER //
// ./src/pages/device-info/index.tsx